import {useI18n} from '@yandex-delivery/core/i18n'
import {useCallback} from 'react'

import {useConfigContext} from '../../../../contexts'
import {EventGoal, useFormUserEventHandler} from '../../../../lib/metrika'
import fallbackSrc from './assets/bg.svg'

export function useBusinessBannerModal(setActive?: (isActive: boolean) => void, utm_source?: string) {
  const i18n = useI18n()
  const {getRegistrationUrl} = useConfigContext()
  const handleReachGoal = useFormUserEventHandler()

  const title = i18n('banner.title.vertical-business', 'Доставка со склада доступна только в кабинете для бизнеса')
  const description =
    i18n('banner.description.vertical-business', {fallBackToKey: false}) ||
    i18n(
      'banner.description.default',
      'Несколько минут на регистрацию — и у вас будет эта и другие возможности Доставки для бизнеса:',
    )
  const list = i18n(
    'banner.list.default',
    'оплата с расчётного счёта\nдоставка негабаритных вещей\nспециальные функции и тарифы.',
  )
  const imageSrc = i18n('banner.image-src.vertical-business', {fallBackToKey: false}) || fallbackSrc

  const queryParams: Record<string, string> = {offer: 'true'}
  if (utm_source) {
    queryParams.utm_source = utm_source
  }

  const handleClose = useCallback(() => {
    setActive?.(false)
  }, [setActive])

  const handleRegisterLinkClick = useCallback(() => {
    handleReachGoal(EventGoal.BannerRegistrationButtonClick)
  }, [handleReachGoal])

  return {
    title,
    description,
    list: list.split('\n').filter(Boolean),
    imageSrc,
    link: getRegistrationUrl(queryParams),
    handleRegisterLinkClick,
    handleClose,
  } as const
}
